import { render, staticRenderFns } from "./bilancio.vue?vue&type=template&id=2e22b907&lang=html&"
import script from "./bilancio.vue?vue&type=script&lang=js&"
export * from "./bilancio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports